import { cn } from './cn';

/** A small ring that turns; it inherits the text colour. */
export function Spinner({ className, label }: { className?: string; label?: string }) {
  const ring = (
    <span
      aria-hidden
      className={cn(
        'inline-block size-3.5 shrink-0 animate-crow-spin rounded-full border-2 border-current border-r-transparent',
        className,
      )}
    />
  );
  if (!label) return ring;
  return (
    <span role="status" className="inline-flex">
      {ring}
      <span className="sr-only">{label}</span>
    </span>
  );
}

/** Placeholder lines shown instead of content that takes more than 300 ms to come. */
export function Skeleton({ lines = 3, className }: { lines?: number; className?: string }) {
  const widths = ['w-[70%]', 'w-[90%]', 'w-[55%]', 'w-[80%]'];
  return (
    <div aria-hidden className={cn('flex flex-col gap-2.5', className)}>
      {Array.from({ length: lines }, (_, i) => ({
        id: `line-${i}`,
        width: widths[i % widths.length],
      })).map((line) => (
        <div
          key={line.id}
          className={cn(
            'h-2.5 animate-crow-skeleton rounded bg-[linear-gradient(90deg,var(--crow-raised),var(--crow-line),var(--crow-raised))] bg-size-[200%_100%]',
            line.width,
          )}
        />
      ))}
    </div>
  );
}
